import { render } from "./RuleProperties.vue?vue&type=template&id=4afc160c"
import script from "./RuleProperties.vue?vue&type=script&lang=js"
export * from "./RuleProperties.vue?vue&type=script&lang=js"

import "./RuleProperties.vue?vue&type=style&index=0&id=4afc160c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__